import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import React from "react";
import { Col, Row } from "react-bootstrap";
import noInternet from "../../Assets/Animations/noInternet.json";
import "../../Assets/Styles/pages/uploadImage.scss";
import LottiePlayer from "../LottiePlayer/lottiePlayer";
import { useTranslation } from "react-i18next";
import ButtonRounded from "../Signature/button";

interface NoInternetModalProps {
  open: boolean;
  /** True while a retry check is in flight -- swaps the button label for a spinner. */
  retrying?: boolean;
  /** Runs a real connectivity check; the caller closes the modal only if it succeeds. */
  onRetry?: () => void;
}

const NoInternetModal: React.FC<NoInternetModalProps> = ({
  open,
  retrying = false,
  onRetry,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 800,
      }}
    >
      <Fade in={open}>
        <Row className="model w-xs-100 d-flex justify-content-center align-items-center py-5 px-3 ">
          <Row className="d-flex justify-content-center align-items-center productSansBold text_30 line_height_100pc">
            {t("NoInternetTitle")}
          </Row>
          <Row className="d-flex justify-content-center align-items-center my-3">
            <Col xs={4}>
              <LottiePlayer src={noInternet} />
            </Col>
          </Row>
          <Row className="d-flex justify-content-center text-center w-75 align-items-center productSans text_18 mb-3 ">
            {t("NoInternetSubTitle")}
          </Row>
          <ButtonRounded
            onclick={() => {
              if (!retrying) onRetry?.();
            }}
            text={"Retry"}
            loader={retrying}
            disabled={retrying}
            style={"w_edit_button  my-0 mb-0 p-0"}
            parrentStyle={"w-50 mt-3"}
          />
          {/* <Row className='d-flex w-25 justify-content-center align-items-center'>
                        <Button >{t("Retry!")}</Button>
                    </Row> */}
        </Row>
      </Fade>
    </Modal>
  );
};

export default NoInternetModal;
